// extracted by mini-css-extract-plugin
export default {"card":"country_card__o0RFC"};